import React from 'react';
import { Outlet } from 'react-router-dom';
import { NavbarGeneral } from '../NavbarGeneral/NavbarGeneral';
import { Footer } from '../Footer/Footer';

/**
 * Wrapper
 * @description: Wrapper de la aplicación Samsung
 * @returns JSX del Screen.
 */
export const Wrapper: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <NavbarGeneral />
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
